(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-grid/assets/javascripts/bingo-grid.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-grid/assets/javascripts/bingo-grid.js');
"use strict";

const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_AM = _svs$components$lbUti.BREAKPOINT_AM,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD;
const _svs$bingo_react$comp = svs.bingo_react.components.bingoCard,
  BingoCard = _svs$bingo_react$comp.BingoCard,
  BingoCardDesktopPromo = _svs$bingo_react$comp.BingoCardDesktopPromo,
  BingoCardDesktop = _svs$bingo_react$comp.BingoCardDesktop;
const useBingoGameRooms = svs.bingo_react.components.useBingoGameRooms;
const useBingoLastWins = svs.bingo_react.components.useBingoLastWins;
const threeSpanClass = ' bingo-grid__grid-item--three-span';
const twoSpanClass = ' bingo-grid__grid-item--two-span';
const halfSpanClass = ' bingo-grid__grid-item--half-span';
const fullSpanClass = ' bingo-grid__grid-item--full-span';
const getGridItemClass = (index, numberOfGames, isSmallScreen) => {
  if (isSmallScreen) {
    return numberOfGames % 2 !== 0 && index === 3 ? fullSpanClass : halfSpanClass;
  }
  switch (numberOfGames) {
    case 2:
      return twoSpanClass;
    case 3:
      return threeSpanClass;
    case 4:
      return twoSpanClass;
    case 5:
      return index < 3 ? twoSpanClass : threeSpanClass;
    case 6:
      return threeSpanClass;
    case 7:
      return index < 3 || index > 5 ? twoSpanClass : threeSpanClass;
    case 8:
      return index < 3 ? twoSpanClass : threeSpanClass;
    default:
      return threeSpanClass;
  }
};
const BingoGrid = () => {
  const isSmallScreen = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const isAlmostDesktopMin = useMediaQuery(breakpoints.up(BREAKPOINT_AM));
  const isAlmostDesktopMax = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const isAlmostDesktop = isAlmostDesktopMin && isAlmostDesktopMax;
  const _useBingoGameRooms = useBingoGameRooms(),
    gameRooms = _useBingoGameRooms.gameRooms,
    numberOfRooms = _useBingoGameRooms.numberOfRooms;
  const _useBingoLastWins = useBingoLastWins(),
    lastWins = _useBingoLastWins.lastWins;
  const classList = ['bingo-grid'];
  if (numberOfRooms % 2 === 0 && (isSmallScreen || isAlmostDesktop)) {
    classList.push('bingo-grid--even-cards');
  }
  if (numberOfRooms === 0) {
    return React.createElement("div", {
      className: "bingo-grid-empty"
    }, React.createElement("h3", {
      className: "h2"
    }, "Strax tillbaka!"), React.createElement("h4", {
      className: "h3"
    }, "Just nu r\xE4knar vi bollar och reng\xF6r v\xE5ra tombolas."));
  }
  return React.createElement("section", {
    className: classList.join(' ')
  }, gameRooms.map((game, i) => {
    var _lastWins$find$timest, _lastWins$find;
    const lastWinTimestamp = (_lastWins$find$timest = (_lastWins$find = lastWins.find(win => win.gameRoomId === game.id)) === null || _lastWins$find === void 0 ? void 0 : _lastWins$find.timestamp) !== null && _lastWins$find$timest !== void 0 ? _lastWins$find$timest : 0;
    const classNames = [];
    if (i === 0) {
      classNames.push('bingo-grid__promo-item');
    } else {
      classNames.push('bingo-grid__grid-item');
      classNames.push(getGridItemClass(i, numberOfRooms - 1, isSmallScreen || isAlmostDesktop));
    }
    if (isSmallScreen) {
      return React.createElement(BingoCard, {
        className: classNames.join(' '),
        gameData: game,
        invertedColors: i === 0,
        key: game.id,
        lastWinTimestamp: lastWinTimestamp,
        promoPosition: i + 1
      });
    }
    if (i === 0) {
      return React.createElement(BingoCardDesktopPromo, {
        className: classNames.join(' '),
        gameData: game,
        key: game.id,
        lastWinTimestamp: lastWinTimestamp
      });
    }
    return React.createElement(BingoCardDesktop, {
      className: classNames.join(' '),
      gameData: game,
      key: game.id,
      lastWinTimestamp: lastWinTimestamp,
      promoPosition: i + 1
    });
  }));
};
setGlobal('svs.bingo_react.components.bingoGrid.BingoGrid', BingoGrid);

 })(window);